import queryString from 'query-string';
import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export const getManyUserEvents = (params) => (dispatch) => {
    const { pathsContext, ...query } = params;
    const url = `${pathsContext.serverUrl}/userevents?${queryString.stringify(query)}`;
    return VerbFetch(url)
        .then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_USER_EVENTS,
                payload: {
                    userEvents: body
                }
            });
            return body;
        })
        .catch((err) => {
            console.error(err);
        });
};

export const getUserEvent = (params) => {
    const { userEventId, pathsContext } = params;
    return (dispatch) => {
        const url = `${pathsContext.serverUrl}/userevents/${userEventId}`;
        return VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_USER_EVENT,
                    payload: {
                        userEvent: body
                    }
                });
                return body;
            })
            .catch((err) => {
                console.error(err);
            });
    };
};

export const postUserEvent = (params) => {
    const { body, dispatchDisabled, pathsContext } = params;
    if (dispatchDisabled) {
        return VerbFetch(`${pathsContext.serverUrl}/userevents`, {
            method: 'POST',
            body
        });
    }
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_USER_EVENT_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.serverUrl}/userevents`, {
            method: 'POST',
            body
        })
            .then((body) => {
                dispatch({
                    type: ACTIONS.POST_USER_EVENT_SUCCESS,
                    payload: {
                        userEvent: body
                    }
                });

                return body;
            })
            .catch((err) => {
                console.error(err);
            });
    };
};

export const putUserEvent = (params) => {
    const { userEventId, body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_USER_EVENT_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.serverUrl}/userevents/${userEventId}`, {
            method: 'PUT',
            body
        })
            .then((body) => {
                dispatch({
                    type: ACTIONS.PUT_USER_EVENT_SUCCESS,
                    payload: {
                        userEvent: body
                    }
                });

                return body;
            })
            .catch((err) => {
                console.error(err);
            });
    };
};
